import { Link } from 'react-router-dom';
import type { QuickNavItem } from '../types';

interface QuickNavButtonsProps {
  items: QuickNavItem[];
}

/**
 * Quick navigation buttons for frequently-accessed pages.
 * Displayed in the sidebar header for one-click access to key documents.
 */
export function QuickNavButtons({ items }: QuickNavButtonsProps) {
  if (items.length === 0) return null;

  return (
    <div className="flex items-center gap-1">
      {items.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          className="inline-flex items-center justify-center rounded-md p-1.5 text-gray-500 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-50"
          title={item.label}
        >
          {item.icon ? (
            <svg
              className="h-4 w-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d={item.icon}
              />
            </svg>
          ) : (
            <span className="text-xs font-medium">
              {item.label.slice(0, 2)}
            </span>
          )}
          <span className="sr-only">{item.label}</span>
        </Link>
      ))}
    </div>
  );
}
